import type { ReactNode } from 'react';
import { Navigate, Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import { PASSWORD_RESET_PATH } from 'shared';

import './components/phage.css';
import { RequireAuth } from './components/RequireAuth.js';
import { ToastProvider } from './components/Toast.js';
import { AddSitePage } from './pages/app/AddSitePage.js';
import { NotFoundPage } from './pages/app/NotFoundPage.js';
import { SitePage } from './pages/app/SitePage.js';
import { SiteSettingsPage } from './pages/app/SiteSettingsPage.js';
import { SitesPage } from './pages/app/SitesPage.js';
import { ForgotPasswordPage } from './pages/auth/ForgotPasswordPage.js';
import { LoginPage } from './pages/auth/LoginPage.js';
import { ResetPasswordPage } from './pages/auth/ResetPasswordPage.js';
import { SignupPage } from './pages/auth/SignupPage.js';
import { OperatorApplicationsPage } from './pages/operator/OperatorApplicationsPage.js';
import { OperatorDamPricesPage } from './pages/operator/OperatorDamPricesPage.js';
import { OperatorSitesPage } from './pages/operator/OperatorSitesPage.js';

const client = (page: ReactNode) => <RequireAuth only="client">{page}</RequireAuth>;
const signedIn = (page: ReactNode) => <RequireAuth>{page}</RequireAuth>;
const admin = (page: ReactNode) => <RequireAuth only="operator">{page}</RequireAuth>;

/**
 * Client: «Об'єкти» (the start after sign-in), «Додати об'єкт», object
 * «Огляд» and «Налаштування». Administrator: «Об'єкти» of all clients,
 * «Заявки», «Ціни РДН» (pages/operator) and the same object screens.
 */
export function App() {
  return (
    <Router>
      <ToastProvider>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/signup" element={<SignupPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path={PASSWORD_RESET_PATH} element={<ResetPasswordPage />} />
          <Route path="/app/sites" element={client(<SitesPage />)} />
          <Route path="/app/sites/new" element={client(<AddSitePage />)} />
          <Route path="/app/sites/:id" element={signedIn(<SitePage />)} />
          <Route path="/app/sites/:id/settings" element={signedIn(<SiteSettingsPage />)} />
          <Route path="/app/admin/sites" element={admin(<OperatorSitesPage />)} />
          <Route path="/app/admin/applications" element={admin(<OperatorApplicationsPage />)} />
          <Route path="/app/admin/dam-prices" element={admin(<OperatorDamPricesPage />)} />
          <Route path="/app" element={<Navigate to="/app/sites" replace />} />
          <Route path="/" element={<Navigate to="/app/sites" replace />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </ToastProvider>
    </Router>
  );
}
